(() => {
  if (window.FCCart) return;
  const configElement = document.getElementById('FCCartConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  let busy = false;
  let pending = Promise.resolve();
  const page = () => document.querySelector('[data-ec-page]');
  const notice = text => page()?.querySelector('[data-ec-feedback]')?.replaceChildren(document.createTextNode(text));
  function renderURL(path) {
    const url = new URL(path, location.origin);
    const current = new URL(location.href);
    for (const key of ['preview_theme_id', '_fd', 'pb']) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    return url;
  }
  const added = () => location.assign(renderURL(config.cart).href);
  function setBusy(value) {
    busy = value;
    page()?.querySelectorAll('button,input').forEach(el => el.disabled = value);
    page()?.setAttribute('aria-busy', String(value));
  }
  async function request(url, body) {
    const response = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: body ? {'Content-Type':'application/json', Accept:'application/json'} : {Accept:'application/json'},
      credentials:'same-origin',
      ...(body ? {body:JSON.stringify(body)} : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || config.error);
    return data;
  }
  function paint(html) {
    const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ec-page]');
    if (!replacement || !page()) throw new Error(config.error);
    const state = JSON.parse(replacement.querySelector('[data-ec-state]').textContent);
    page().replaceWith(replacement);
    document.querySelectorAll('[data-fc-cart-count],[data-cart-count],.js-cart-count').forEach(el => {el.textContent = state.count;el.hidden = state.count === 0;});
    return state;
  }
  async function refresh() {
    if (!page()) return;
    const url = renderURL(config.cart);
    const id = page().dataset.sectionId;
    url.searchParams.set('sections', id);
    try { return paint((await request(url.href))[id]); }
    catch {
      url.searchParams.delete('sections');
      const response = await fetch(url.href, {credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'}});
      if (!response.ok || new URL(response.url).pathname !== url.pathname) throw new Error(config.error);
      return paint(await response.text());
    }
  }
  function queueChange(key, quantity) {
    if (busy || !Number.isSafeInteger(quantity) || quantity < 0) return;
    const activeKey = document.activeElement?.dataset?.ecKey;
    setBusy(true);
    notice(config.updating);
    pending = (async () => {
      let changed = false;
      try {
        const id = page().dataset.sectionId;
        const context = renderURL(config.cart);
        const cart = await request(config.change, {id:key,quantity,sections:[id],sections_url:context.pathname + context.search});
        changed = true;
        try {paint(cart.sections?.[id]);} catch {await refresh();}
        notice(config.updated);
        if (activeKey) page()?.querySelector('[data-ec-key="' + CSS.escape(activeKey) + '"]')?.focus({preventScroll:true});
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
      } catch (error) {
        if (changed) {added();return;}
        page()?.querySelectorAll('[data-ec-key]').forEach(input => input.value = input.dataset.ecSaved);
        notice(error.message || config.error);
      } finally {setBusy(false);}
    })();
  }
  async function acceptOffer(offer) {
    if (busy) return;
    let accepted = false;
    setBusy(true);
    offer.querySelector('[data-ec-accept-label]').textContent = config.adding;
    offer.querySelector('[data-ec-offer-error]').textContent = '';
    try {
      await request(config.add,{items:[{id:Number(offer.dataset.ecVariant),quantity:Number(offer.dataset.ecQuantity) || 1}]});
      accepted = true;
      await refresh();
      notice(config.offer_added);
      page()?.querySelector('[data-ec-feedback]')?.setAttribute('tabindex','-1');
      page()?.querySelector('[data-ec-feedback]')?.focus({preventScroll:true});
    } catch (error) {
      if (accepted) {added();return;}
      offer.querySelector('[data-ec-offer-error]').textContent = error.message || config.error;
      offer.querySelector('[data-ec-accept-label]').textContent = config.add_offer;
    } finally {setBusy(false);}
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const opener = target.closest('.fc-erecta-cart-icon,[data-ec-open],[data-fc-cart-open]');
    if (opener && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();added();return;
    }
    const step = target.closest('[data-ec-step]');
    if (step) {
      const input = step.closest('[data-ec-quantity]').querySelector('input');
      if (input.disabled || busy) return;
      const old = Number(input.value) || Number(input.min) || 0;
      const value = Math.max(Number(input.min)||0,Math.min(input.max?Number(input.max):Number.MAX_SAFE_INTEGER,old + Number(step.dataset.ecStep)*(Number(input.step)||1)));
      input.value = value;
      if (input.dataset.ecKey) queueChange(input.dataset.ecKey,value);
      return;
    }
    const remove = target.closest('[data-ec-remove]');
    if (remove) {event.preventDefault();queueChange(remove.dataset.ecRemove,0);return;}
    const accept = target.closest('[data-ec-accept]');
    if (accept) {event.preventDefault();acceptOffer(accept.closest('[data-ec-offer]'));}
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('[data-ec-key]')) return;
    if (!input.checkValidity() || !Number.isSafeInteger(Number(input.value))) {input.value=input.dataset.ecSaved;return;}
    if (Number(input.value)!==Number(input.dataset.ecSaved)) queueChange(input.dataset.ecKey,Number(input.value));
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('[data-ec-form]')) {
      if (event.submitter?.name==='update') return;
      event.preventDefault();
      await pending;
      if (busy || !page()?.querySelector('[data-ec-form]')) return;
      setBusy(true);
      const checkout = document.createElement('form');
      checkout.action=config.cart;checkout.method='post';checkout.hidden=true;
      const input=document.createElement('input');input.name='checkout';input.value='checkout';
      checkout.append(input);document.body.append(checkout);checkout.submit();
      return;
    }
    if (!form.matches('[data-ec-product-form]')) return;
    event.preventDefault();
    if (form.dataset.ecBusy) return;
    form.dataset.ecBusy='true';
    const button=form.querySelector('[type="submit"]');
    const original=button.textContent;
    button.disabled=true;button.textContent=config.adding;
    try {
      const fields=new FormData(form);
      await request(config.add,{items:[{id:Number(fields.get('id')),quantity:Number(fields.get('quantity'))}]});
      added();
    } catch (error) {form.querySelector('[data-ec-feedback]').textContent=error.message||config.error;}
    finally {delete form.dataset.ecBusy;button.disabled=false;button.textContent=original;}
  });
  document.addEventListener('fc:cart:added',added);
  window.addEventListener('pageshow',async event => {
    if (!event.persisted) return;
    try {await refresh();} catch {notice(config.error);}
    setBusy(false);
  });
  window.FCCart={added,refresh,open:added};
})();
